export const UIKeyBorderType={
    None:0,
    Delete:1,
    Revoke:2,
    RollBack:3,
    Cancel:4,
    Save:5
};
